var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-input',_vm._g(_vm._b({},'vs-input',Object.assign({}, _vm.$attrs,
  {value: _vm.value,
  labelPlaceholder: _vm.labelPlaceholder,
  label: _vm.label,
  autofocus: _vm.autofocus,
  icon: _vm.icon,
  iconAfter: _vm.iconAfter,
  iconNoBorder: _vm.iconNoBorder,
  iconPack: _vm.iconPack,
  color: _vm.color,
  success: _vm.success,
  danger: _vm.danger,
  warning: _vm.warning,
  successText: _vm.successText,
  warningText: _vm.warningText,
  dangerText: _vm.dangerText,
  descriptionText: _vm.descriptionText,size: _vm.size,
  valIconPack: _vm.valIconPack,
  valIconSuccess: _vm.valIconSuccess,
  valIconDanger: _vm.valIconDanger,
  valIconWarning: _vm.valIconWarning}),false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }